export default {
  URL: 'url',
  CODE: 'code',
};
